<template>
  <v-container grid-list-xl fluid class="pt-0">

    <v-layout row wrap>
      <v-flex md2>
        <simple-month-picker v-model="filter.month" label="Mes" ></simple-month-picker>
      </v-flex>
      <v-flex md2>
        <v-btn color="primary" flat @click="getInstallationRecordsInfo">Continuar</v-btn>
      </v-flex>
    </v-layout>

    <!-- panel1 -->
    <div v-if="panel1 && searched">


      <!-- <v-toolbar dark color="primary">
        <v-btn icon dark @click="searched = false; ">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-flex sm3>
            <v-text-field color="white" placeholder="xx.xxx.xxx-x" mask="##.###.###-N" v-on:keyup.enter="getEmployees" dark clearable hide-details label="Rut" v-model='filter.employeeRut'></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field color="white" placeholder="Nombre" v-on:keyup.enter="getEmployees" dark clearable hide-details label="Nombre" v-model='filter.employeeFullName'></v-text-field>
          </v-flex>
          <v-flex sm4>
            <v-text-field color="white" placeholder="Cargo" v-on:keyup.enter="getEmployees" dark clearable hide-details label="Cargo" v-model='filter.employeeTitle'></v-text-field>
          </v-flex>
        </v-layout>
        <v-btn icon flat @click="getEmployees"><v-icon medium>search</v-icon></v-btn>
      </v-toolbar> -->


      <!-- table -->
      <v-data-table :headers="headers" :items="items" :loading="loadingItems" class="elevation-1" rows-per-page-text='Mostrar' :rows-per-page-items="[10, 50]">
        <template v-slot:items="props">
          <td>{{ props.item.installation_name }}</td>
          <td>{{ props.item.employeeCompanyName }}</td>
          <td>{{ props.item.count_records }}</td>
        </template>
        <!-- <template v-slot:footer>
          <td :colspan="4">
            <strong>{{items.length}} personas con registros.</strong>
          </td>
        </template> -->
      </v-data-table>
      <!-- ./table -->
    </div>
    <!-- ./panel1 -->


  </v-container>
</template>


<script>

import moment from 'moment'
import axios from 'axios';
import SimpleMonthPicker from '@/components/app/monthPicker';


export default {
  components: {
    SimpleMonthPicker,
  },
  data: () => ({
    searched : false,
    filter : {
      month: moment().format('YYYY-MM')
    },
    items : [],
    loadingItems:false,
    headers: [
      { text: 'Instalación', value: 'installation_name' },
      { text: 'Empresa', value: 'employeeCompanyName' },
      { text: 'Registros', value: 'count_records' },
    ],
    panel1: true,
  }),
  watch: {
    'filter.month' : function(val){
      if(val){
        // this.getCompanies();
      }else{
        this.companies = [];
        this.filter = {};
        this.items = [];
      }
    }
  },
  created(){
    // let today = new Date();
    // this.filter.month = moment(today).format('YYYY-MM')
    // console.log(moment(today).format('YYYY-MM-DD'));
  },
  mounted () {
    axios.defaults.headers.post['Accept'] = 'application/json';
    axios.defaults.baseURL = localStorage.getItem('ipApiServer');
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token');

    if(this.filter.month){
      // this.getCompanies();
    }
  },
  methods: {
    getInstallationRecordsInfo () {
      let $this = this;
      let params = Object.assign(this.filter);
      $this.loadingItems = true;
      axios.get( 'admin/getInstallationRecordsInfo', { params : params } )
           .then( function(response){
             $this.items = response.data;
             $this.loadingItems = false;
             $this.searched = true;
           })
           .catch(error => {
             if(error.response.status == 422){
               window.getApp.$emit('APP_BAD_REQUEST', error.response.data.message);
             }
           });
    },
  }

};

</script>
